module.exports = __webpack_public_path__ + "static/media/challenge-icon.c0dd02ac.svg";